import styled from "styled-components"
import { respondTo } from "theme/base/Mixins"

const CardsDetailsStyled = styled.div`
  .cards-container {
    display: grid;
    grid-template-columns: repeat(1, 1fr); /* Mobile por defecto */
    gap: 16px;
    padding: 16px;
  }

  .card-title {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 0.5rem;
    width: 100%;
    padding: 0.3rem 0;
    text-align: center;
    font-weight: 600;
    background: #ECEDF1;
    color: #3E405B;
    font-size: 1rem;
  }

  .card {
    background: white;
    border-radius: 12px;
    box-shadow: 0 2px 6px rgba(0,0,0,0.1);
    padding: 16px;
  }

  /* Tablet: 2 columnas */
  ${respondTo.sm`
      .cards-container {
        grid-template-columns: repeat(2, 1fr);
      }
    }
  `}

  /* Desktop: 3 columnas */
 ${respondTo.lg`
    .cards-container {
      grid-template-columns: repeat(3, 1fr);
    }
  `}
`

export default CardsDetailsStyled